module.exports = __webpack_public_path__ + "img/beer_id-29.577d71da.png";